import { ERROR_MESSAGES } from 'src/app/constants';
import { toAbsoluteMonth } from 'src/app/month.util';

export interface FiscalYearInfo {
	BranchId: number;
	BusinessId: number;
	FiscalYear: number;
	Amount: number;
	CfAdjustment: number;
	// AbsStartMonth?: number;
	// AbsEndMonth?: number;
}

export function createEmptyFiscalYearInfo(): FiscalYearInfo {
	return {
		BusinessId: undefined,
		BranchId: undefined,
		FiscalYear: undefined,
		Amount: 0,
		CfAdjustment: 0
	};
}

export type FiscalYearInfoAbsMonths = FiscalYearInfo & {
	AbsStartMonth?: number, AbsEndMonth?: number };

export function toFiscalYearInfoAbsMonths(obj: FiscalYearInfo, yearEnd: number): FiscalYearInfoAbsMonths {
	return {
		...obj,
		AbsStartMonth: toAbsoluteMonth(obj.FiscalYear - 1, yearEnd + 1),
		AbsEndMonth: toAbsoluteMonth(obj.FiscalYear, yearEnd)
	}
}

// --- Mapper -------------------------------------------------------------------------------------

export interface FiscalYearInfoDTO {
	businessId: number;
	businessBranchId: number;
	fiscalYear: number;
	auditTargetAmount: number;
	carryForwardAmountAdjustment: number;
}

export const FiscalYearInfoAdapter = {
	adapt: (item: Partial<FiscalYearInfoDTO>): FiscalYearInfo => ({
		BusinessId: item.businessId!,
		BranchId: item.businessBranchId!,
		FiscalYear: item.fiscalYear!,
		Amount: item.auditTargetAmount!,
		CfAdjustment: item.carryForwardAmountAdjustment ?? 0
	}),
	toAPIModel: (fiscalYearInfo: Partial<FiscalYearInfo>): Partial<FiscalYearInfoDTO> => ({
		auditTargetAmount: fiscalYearInfo.Amount,
		carryForwardAmountAdjustment: fiscalYearInfo.CfAdjustment
	})
};

// --- Validator ----------------------------------------------------------------------------------

export const FiscalYearValidator = {
	isNull: (fy: FiscalYearInfo): string[] => {
		const errors: string[] = [];
		if (fy.BranchId == null) errors.push(ERROR_MESSAGES.EMPTY_FIELD('Business Branch'));
		if (fy.FiscalYear == null) errors.push(ERROR_MESSAGES.EMPTY_FIELD('Fiscal Year'));
		if (fy.Amount == null) errors.push(ERROR_MESSAGES.EMPTY_FIELD('Target Amount'));
		return errors;
	}
};